import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Moment from "react-moment";

import ImagesHorizontal from "../global/image/ImagesHorizontal";
import { getPromo } from "../../actions/admin/promo";

const Detail = ({ getPromo, id }) => {
    const [promoData, setPromoData] = useState({
        title: "",
        description: "",
        images: [],
        categoryIds: [],
        source: "",
        isDeal: false,
        isEvent: false,
        dateFrom: new Date(),
        dateTill: new Date(),
        dateCreated: new Date(),
        dateUpdated: new Date()
    });

    const {
        title,
        description,
        images,
        categories,
        source,
        isDeal,
        isEvent,
        dateFrom,
        dateTill,
        dateCreated,
        dateUpdated
    } = promoData;

    useEffect(() => {
        const fetchPromoData = async () => {
            const promo = await getPromo(id);

            setPromoData({
                title: promo.title,
                description: promo.description,
                images: promo.images.length
                    ? promo.images.map(image => {
                          return {
                              source: image
                          };
                      })
                    : [],
                categories: promo.categories,
                source: promo.source,
                isDeal: promo.isDeal,
                isEvent: promo.isEvent,
                dateFrom: promo.dateFrom,
                dateTill: promo.dateTill,
                dateCreated: promo.dateCreated,
                dateUpdated: promo.dateUpdated
            });
        };

        fetchPromoData();
    }, [id, getPromo]);

    return (
        <Fragment>
            <div className="row form-group">
                <div className="col-md-3">Title:</div>
                <div className="col-md-9">{title}</div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Description:</div>
                <div className="col-md-9">{description}</div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Source:</div>
                <div className="col-md-9">{source}</div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Categories:</div>
                <div className="col-md-9">
                    <ul className="list-inline mb-0">
                        {categories &&
                            categories.map((category, index) => (
                                <li key={index}>{category.name}</li>
                            ))}
                    </ul>
                </div>
            </div>
            <div className="form-group">
                <div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isDeal"
                                value="true"
                                checked={isDeal === true}
                                onChange={() => {}}
                                disabled
                            />{" "}
                            Is Deal
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="radio-inline">
                            <input
                                type="radio"
                                name="isEvent"
                                value="false"
                                checked={isEvent === true}
                                onChange={() => {}}
                                disabled
                            />{" "}
                            Is Event
                        </label>
                    </div>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Date From:</div>
                <div className="col-md-9">
                    <Moment format="DD-MM-YYYY HH:mm">{dateFrom}</Moment>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Date Till:</div>
                <div className="col-md-9">
                    <Moment format="DD-MM-YYYY HH:mm">{dateTill}</Moment>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Date Created:</div>
                <div className="col-md-9">
                    <Moment format="DD-MM-YYYY HH:mm">{dateCreated}</Moment>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Date Updated:</div>
                <div className="col-md-9">
                    <Moment format="DD-MM-YYYY HH:mm">{dateUpdated}</Moment>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Images:</div>
                <div className="col-md-9">
                    {images.length ? (
                        <ImagesHorizontal images={images}></ImagesHorizontal>
                    ) : (
                        <Fragment></Fragment>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

Detail.propTypes = {
    getPromo: PropTypes.func.isRequired
};

export default connect(null, { getPromo })(Detail);
